import React from 'react'
import { Container, TextBody, ListContainer } from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const SummaryPrice = ({
  subtotal,
  delivery,
  deliveryFlat,
  discount,
  discountFlat,
  translations,
  surchargeValue,
  surchargeTitle
}) => {
  return (
    <Container divider={Container.dividers.top}>
      <Container pb="6" pt="6">
        <ListContainer columns={2} xBetween="2">
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_summarySubtotal')}
            />
          </Container>
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              alignment={TextBody.alignments.right}
              data-testing="Checkout_TextBody_Subtotal">
              {subtotal}
            </TextBody>
          </Container>
        </ListContainer>
      </Container>
      <Container pb="6">
        <ListContainer columns={2} xBetween="2">
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_summaryDelivery')}
            />
          </Container>
          <Container fullWidth>
            {deliveryFlat === 0 ? (
              <TextBody
                size={TextBody.sizes.m}
                additionalClasses="q-text-turquoise"
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_FreeShipping"
                {...htmlTranslation(translations, 'tk_freeShipping')}
              />
            ) : (
              <TextBody
                size={TextBody.sizes.m}
                additionalClasses="q-text-turquoise"
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_Delivery">
                {delivery}
              </TextBody>
            )}
          </Container>
        </ListContainer>
      </Container>
      {surchargeValue && (
        <Container pb="6">
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.grayedout}
                data-testing="Checkout_TextBody_SurchargeTitle">
                {surchargeTitle}
              </TextBody>
            </Container>
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_SurchargeValue">
                {surchargeValue}
              </TextBody>
            </Container>
          </ListContainer>
        </Container>
      )}
    </Container>
  )
}

export default SummaryPrice
